module.exports = __webpack_public_path__ + "img/noSale.c12e75c3.png";